import React from 'react';
import { Button, Typography, Box, useTheme } from '@material-ui/core';
import CustomModal from '../../common/CustomModal/CustomModal';
import { useTranslation } from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';
import { IssuePrescriptionResponse, PrescriptionVerificationResult } from '../../../types/prescription';
import { P1Response } from '../../../types/p1Service';
import WarningIcon from '../../common/icons/WarningIcon/WarningIcon';
import ErrorIcon from '../../common/icons/ErrorIcon/ErrorIcon';
import { P1_ERROR_SUFFIX, P1_WARNING_SUFFIX } from '../../../const/p1';

interface PrescriptionP1MessagePopupProps {
    open: boolean;
    onClose: () => void;
    p1Response?: P1Response<IssuePrescriptionResponse>;
}

const PrescriptionP1MessagePopup: React.FC<PrescriptionP1MessagePopupProps> = ({
    open,
    onClose,
    p1Response,
}) => {
    const {t: commonT} = useTranslation(i18nNamespaces.COMMON);
    const {t} = useTranslation(i18nNamespaces.ERRORS);
    const results = p1Response?.result?.results;
    const isSuccess = p1Response?.isSuccess;
    const message = p1Response?.message;

    const getMessageIconByResult = (result: string) => {
        if (result.endsWith(P1_WARNING_SUFFIX)) {
            return <WarningIcon />;
        } else if (result.endsWith(P1_ERROR_SUFFIX)) {
            return <ErrorIcon />;
        }
    }

    const formatMessage = (message: PrescriptionVerificationResult) => 
        `${message.code} - ${message.description}`;

    const getTitle = () => {
        if(isSuccess) {
            return t('successConfirmationPopupTitle.prescription');
        } else {
            return t('noSuccessConfirmationPopupTitle.prescription');
        }
    }

    return (
        <CustomModal open={open} onClose={onClose}>
            <>
            <Box display="flex" flexDirection="column" alignItems="center">
                <Typography style={{fontWeight: 'bold', textAlign: 'center', marginBottom: 16}} gutterBottom>
                    {getTitle()}
                </Typography>
                {!isSuccess && results?.length === 0 && <span>{t('noSuccessConfirmationPopupDescription')}</span>}
                {results?.map((result, index) => (
                    <Box key={index}>
                        {result.results.map((res, idx) => (
                            <Box key={idx} style={{display: 'flex', alignItems: 'flex-start', gap: 8}} mb={1}>
                                {getMessageIconByResult(res.result)} {formatMessage(res)}
                            </Box>
                        ))}
                    </Box>
                ))}
                <Button 
                    variant="contained" 
                    color="secondary" 
                    onClick={onClose} 
                    style={{marginTop: 8}} 
                    fullWidth
                >
                    {isSuccess ? commonT('goBack') : commonT('close')}
                </Button>
            </Box>
            </>
        </CustomModal>
    );
};

export default PrescriptionP1MessagePopup;